import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { add } from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { LanguageTranslateService } from 'src/app/_services/language-translate.service';
import { PreventiveMaintenanceStandaloneService } from 'src/app/_services/preventive-maintenance-standalone.service';
import { ErrorUtil } from 'src/app/_utilities/error';
import { AuthenticationService } from 'src/app/auth/authentication.service';

@Component({
    selector: 'app-preview-selected-plan',
    templateUrl: './preview-selected-plan.component.html',
    styleUrls: ['./preview-selected-plan.component.scss'],
    standalone: false
})
export class PreviewSelectedPlanComponent implements OnInit {
  selection: any[];
  contextLabel = 'assets'; // or 'assets'
  data: any;
  timezone: any;
  dateFormat: any
  translate: any;
  addAssetToPlan:any={
    maintainancePlan: {id: 13},
    assets: [ ],
    assetStatuses: [ ],
    customerIds: null,
    assetTypes: null,
    createdDateTimeFrom: null,
    createdDateTimeTo: null,
    search: null,
    selectAll: false
}

addSiteToPlanExamplePayload =
{
    maintainancePlan: { id: null },
    sites: null,
    typeIds:null,
    siteStatusIds:null,
    projectIds:null,
    customerIds:null,
    search: null,
    selectAll: true,
    createdDateTimeFrom: null,
    createdDateTimeTo: null
}

  constructor(public modalRef: BsModalRef,
    private auth: AuthenticationService,
    private languageTranslateService: LanguageTranslateService,
    private preventiveMaintenanceStandaloneService: PreventiveMaintenanceStandaloneService,
    private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log('data in preview', this.data);
     this.timezone = this.auth.getUserTimezone();
    this.dateFormat = localStorage.getItem('date_format');
    if(this.data.contextLabel == 'Assets'){
      this.selection = this.data.selectedData
      this.contextLabel = this.data.contextLabel;
      this.addAssetToPlan.maintainancePlan.id = this.data.planId;
      this.addAssetToPlan.selectAll = this.data.selectAll;
      if(this.data.selectAll){
        this.addAssetToPlan.assetStatuses = this.data.filter.assetStatuses;
        this.addAssetToPlan.assetTypes = this.data.filter.assetTypes;
        this.addAssetToPlan.createdDateTimeFrom = this.data.filter.createdDateTimeFrom;
        this.addAssetToPlan.createdDateTimeTo = this.data.filter.createdDateTimeTo;
        this.addAssetToPlan.search = this.data.filter.search;
      }

  }else{
      this.selection = this.data.selectedData
      this.contextLabel = this.data.contextLabel;
      this.addSiteToPlanExamplePayload.maintainancePlan.id = this.data.planId;
      this.addSiteToPlanExamplePayload.selectAll = this.data.selectAll;
      if(this.data.selectAll){
        this.addSiteToPlanExamplePayload.siteStatusIds = this.data.filter.siteStatusIds;
        this.addSiteToPlanExamplePayload.typeIds = this.data.filter.typeIds;
        this.addSiteToPlanExamplePayload.createdDateTimeFrom = this.data.filter.createdDateTimeFrom;
        this.addSiteToPlanExamplePayload.createdDateTimeTo = this.data.filter.createdDateTimeTo;
        this.addSiteToPlanExamplePayload.search = this.data.filter.search;
      }

  }

     this.getLanguageData();
     console.log('preview data', this.selection);
  }
  // *************************** Asset: get language data ************************************
   getLanguageData() {
     this.spinner.show()
   
      this.languageTranslateService.wordSrc$.subscribe((data) => {
        if (Object.keys(data).length != 0) {
          this.translate = data;
          this.spinner.hide();
        }
      })
    
  }

  onBack() {
    // close and return to previous screen; or emit event
    this.modalRef.hide();
  }

  confirmAdd() {
    // emit selection to parent & close
    //this.spinner.show();
    if(this.data.contextLabel == 'Sites'){
      this.confirmAddSitesToPlan();
    }else{
      this.confirmAddAssetsToPlan();
    }
   
  }

  confirmAddSitesToPlan(){
    this.spinner.show();
    // if(!this.addSiteToPlanExamplePayload.selectAll){
    //   this.selection.forEach(element => {
    //     this.addSiteToPlanExamplePayload.sites.push({id: element.id});
    //   });
    // }
    this.addSiteToPlanExamplePayload.sites=[...this.selection];
    console.log('confirm add sites to plan', this.addSiteToPlanExamplePayload);
    
    this.preventiveMaintenanceStandaloneService.saveMultipleSiteToPlan(this.addSiteToPlanExamplePayload).subscribe((res: any) => {
        this.spinner.hide();
        if ([200, 201].includes(res.status)) {
          this.modalRef.hide();
         this.errorUtil.setErrorMessage(200, this.translate.general.messages.addedSuccessfully, null, "success", 3000);
         this.router.navigate(["dashboard/preventative-maintenance-standalone/sitesList/view/" + this.data.planId],{ queryParams: { id: this.data.planId } });
        } else {
          this.errorUtil.setErrorMessage(res.status, null, res.error.title, "error", 3000);
        }
      });

  }

  confirmAddAssetsToPlan(){
    this.spinner.show();
    if(!this.addAssetToPlan.selectAll){
    this.selection.forEach(element => {
      this.addAssetToPlan.assets.push({id: element.id});
    });
  }
    console.log('confirm add assets to plan', this.addAssetToPlan);
    
    this.preventiveMaintenanceStandaloneService.saveMultipleAssetToPlan(this.addAssetToPlan).subscribe((res: any) => {
        this.spinner.hide();
        if ([200, 201].includes(res.status)) {
          this.modalRef.hide();
         this.errorUtil.setErrorMessage(200, this.translate.general.messages.addedSuccessfully, null, "success", 3000);
         this.router.navigate(["dashboard/preventative-maintenance-standalone/assetsList/view/" + this.data.planId],{ queryParams: { id: this.data.planId } });
        } else {
          this.errorUtil.setErrorMessage(res.status, null, res.error.title, "error", 3000);
        }
      });


    
  }

}
